__turbopack_context__.v({
  "addressBar": "RhModule-module__GYapzq__addressBar",
  "balanceCard": "RhModule-module__GYapzq__balanceCard",
  "balanceInfo": "RhModule-module__GYapzq__balanceInfo",
  "browserBar": "RhModule-module__GYapzq__browserBar",
  "candMatch": "RhModule-module__GYapzq__candMatch",
  "candName": "RhModule-module__GYapzq__candName",
  "candidateCard": "RhModule-module__GYapzq__candidateCard",
  "candidateList": "RhModule-module__GYapzq__candidateList",
  "clockCard": "RhModule-module__GYapzq__clockCard",
  "currentDate": "RhModule-module__GYapzq__currentDate",
  "currentTime": "RhModule-module__GYapzq__currentTime",
  "dashboardBody": "RhModule-module__GYapzq__dashboardBody",
  "desktopMockup": "RhModule-module__GYapzq__desktopMockup",
  "dots": "RhModule-module__GYapzq__dots",
  "empAvatar": "RhModule-module__GYapzq__empAvatar",
  "empInfo": "RhModule-module__GYapzq__empInfo",
  "empName": "RhModule-module__GYapzq__empName",
  "empRole": "RhModule-module__GYapzq__empRole",
  "empRow": "RhModule-module__GYapzq__empRow",
  "empStatus": "RhModule-module__GYapzq__empStatus",
  "fadeIn": "RhModule-module__GYapzq__fadeIn",
  "fadeInRight": "RhModule-module__GYapzq__fadeInRight",
  "jobCard": "RhModule-module__GYapzq__jobCard",
  "jobHeader": "RhModule-module__GYapzq__jobHeader",
  "jobPlatform": "RhModule-module__GYapzq__jobPlatform",
  "jobTitle": "RhModule-module__GYapzq__jobTitle",
  "listContainer": "RhModule-module__GYapzq__listContainer",
  "listHeader": "RhModule-module__GYapzq__listHeader",
  "mockupContainer": "RhModule-module__GYapzq__mockupContainer",
  "punchBtn": "RhModule-module__GYapzq__punchBtn",
  "punchItem": "RhModule-module__GYapzq__punchItem",
  "punchLabel": "RhModule-module__GYapzq__punchLabel",
  "punchList": "RhModule-module__GYapzq__punchList",
  "punchMissing": "RhModule-module__GYapzq__punchMissing",
  "punchTime": "RhModule-module__GYapzq__punchTime",
  "scaleIn": "RhModule-module__GYapzq__scaleIn",
  "slideUp": "RhModule-module__GYapzq__slideUp",
  "statusActive": "RhModule-module__GYapzq__statusActive",
  "statusVacation": "RhModule-module__GYapzq__statusVacation",
});
